import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { UrlHelper } from '../../helper/url.helper';
import { AuthService } from '../../service/auth.service';
import { TenantService } from '../../service/tenant.service';
import { Competition } from '../../model/competition/Competition';
import { LocalStorageService } from 'ngx-webstorage';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit, OnDestroy {

  @Input() showText = false;
  @Input() autoClose = false;
  @Input() vertical = false;
  @Input() redirectOnInteraction = false;
  @Input() sidenav: MatSidenav | undefined;

  private tenantSubscription: Subscription | undefined;
  private tenantCheckedSubscription: Subscription | undefined;

  tenant!: Competition | null;
  tenantChecked = false;

  constructor(private authService: AuthService,
              private tenantService: TenantService,
              private localStorageService: LocalStorageService,
              private cdRef: ChangeDetectorRef,
              private router: Router) {
  }

  ngOnInit(): void {
    this.tenant = this.tenantService.getTenant();
    this.tenantChecked = this.tenantService.getTenantChecked();

    this.tenantSubscription = this.tenantService.getTenantUpdates().subscribe(tenant => {
      this.tenant = tenant;
    });
    this.tenantCheckedSubscription = this.tenantService.getTenantCheckedUpdates().subscribe(checked => {
      if (checked != undefined) {
        this.tenantChecked = checked;
        this.cdRef.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this.tenantService.unsubscribe(this.tenantSubscription);
    this.tenantService.unsubscribe(this.tenantCheckedSubscription);
  }

  redirectHome() {
    if (!this.redirectOnInteraction) return;

    void this.authService.getSession()
      .then(async session => {
        if (session.isValid()) {
          await this.router.navigate([UrlHelper.DEFAULT_AUTH_PATH]);

          if (this.autoClose && this.sidenav) {
            await this.sidenav.close();
          }
        } else {
          await this.router.navigate([UrlHelper.SIGN_IN_PATH]);
        }
      });
  }
}
